import { useSite } from "@/context/SiteContext";
import { SmartLink } from "@/components/SmartLink";

export const Footer = () => {
  const site = useSite();
  return (
    <footer className="mt-24 bg-navy-900 text-white/80" data-testid="site-footer">
      <div className="brand-bars flex h-1.5 overflow-hidden" aria-hidden="true">
        <span className="flex-[6] bg-navy" /><span className="flex-1 bg-brand-sky" /><span className="flex-1 bg-brand-orange" /><span className="flex-[2] bg-brand-red" />
      </div>
      <div className="container-site grid gap-10 py-14 md:grid-cols-[1.4fr_1fr]">
        <div>
          <p className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-testid="footer-company-name">{site.company_name}</p>
          <p className="mt-2 text-[15px]" data-testid="footer-trade-registry">Ticaret Sicil No: {site.trade_registry_no}</p>
          <p className="mt-1 text-[15px]">{site.footer_note}</p>
          <a href={`mailto:${site.email}`} className="mt-4 inline-block font-semibold text-white underline decoration-white/30 hover:decoration-white" data-testid="footer-email-link">
            {site.email}
          </a>
        </div>
        <nav aria-label="Alt menü">
          <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-[15px]">
            {(site.footer_links || []).map((l) => (
              <li key={l.label}>
                <SmartLink item={l} className="hover:text-white hover:underline" testId={`footer-link-${(l.to || "mkk").replace(/\W+/g, "")}`}>{l.label}</SmartLink>
                {l.external && site.mkk_note && <span className="mt-1 block text-xs text-white/65" data-testid="footer-mkk-note">{site.mkk_note}</span>}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <p className="container-site py-5 text-sm text-white/60">© {new Date().getFullYear()} {site.company_display_name}</p>
      </div>
    </footer>
  );
};
